import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import axios from "axios";
import { Globals } from "./constants";
import { Helmet } from "react-helmet";
import { canonicalLink, getCDNUrl, hyphen2space } from "./HelperFunctions";

class InvitedByFriend extends Component {
  state = {
    inviteCode: null,
    prizePoint: "20",
    discount: "75",
  };

  linkToFantasy = "";

  user = JSON.parse(localStorage.getItem("user"));

  returnThingsToDoRow = (index, point) => {
    return (
      <div className={`d-flex mt-3`}>
        {/*<div
          className={`pr-3`}
          style={{
            minWidth: `30px`,
          }}
        >
          <h2 className={"font-weight-bold m-f-14 redCl"}>{`${
            index + 1 < 10 ? "0" : ""
          }${index + 1}`}</h2>
        </div>*/}
        <div>
          <h2 className={"m-f-14 "}>{point}</h2>
        </div>
      </div>
    );
  };

  getUserByInviteCode = async (inviteCode) => {
    let url = `${Globals.UserManagment}api/v1/users/get-user-by-ic`;
    // http://localhost:3000/api/v1/users/get-user-by-ic?inviteCode=T62hCWrKTUoEAeIITQnyp
    let userReturnedFromApi = await axios.get(url, {
      params: {
        inviteCode,
      },
    });
    userReturnedFromApi = userReturnedFromApi.data;
    if (userReturnedFromApi.status === 1) {
      userReturnedFromApi = userReturnedFromApi.data;
      return {
        inviterId: userReturnedFromApi.id,
        inviterMsisdn: userReturnedFromApi.msisdn,
        inviterName: userReturnedFromApi.name,
      };
    } else {
      console.log(
        `Error in invited friend get user by invite code`,
        userReturnedFromApi.message
      );
      return null;
    }
  };

  async componentDidMount() {
    const inviteCode = this.props.match.params.inviteCode;
    if (inviteCode.length) {
      let user = await this.getUserByInviteCode(inviteCode);
      if (!user) this.props.history.push(`/`);
      this.setState({
        inviteCode: user.inviterName && user.inviterName.length
          ? user.inviterName
          : user.inviterMsisdn,
      });
      let invitedUser = {
        inviterId: user.inviterId,
        inviterMsisdn: user.inviterMsisdn,
        seriesId: this.props.match.params.seriesId,
        matchId: this.props.match.params.matchId,
        leagueId: this.props.match.params.leagueId,
        constantId: this.props.match.params.constantId,
      };
        if (
          invitedUser.seriesId &&
          invitedUser.matchId &&
          invitedUser.leagueId &&
          invitedUser.constantId
        ) {
          localStorage.setItem(
            "redirect_after_login",
            `/fantasy?createTeam=true&seriesId=${
              invitedUser.seriesId
            }&matchId=${invitedUser.matchId}&leagueId=${
              invitedUser.leagueId
            }&constantId=${invitedUser.constantId}`
          );
          this.linkToFantasy =  `/fantasy?createTeam=true&seriesId=${
            invitedUser.seriesId
          }&matchId=${invitedUser.matchId}&leagueId=${
            invitedUser.leagueId
          }&constantId=${invitedUser.constantId}`;

          if (this.user) {
            this.props.history.push(this.linkToFantasy);
            localStorage.removeItem("redirect_after_login");
      localStorage.removeItem("invitedUser");
          }
        }
        else localStorage.setItem("redirect_after_login", `/fantasy`);
    }
  }

  render() {
    return (
      <section
        id="main-section"
        className="px-lg-0 jc-inner-page align-self-start"
      >
        <Helmet>
          <meta property="apple-itunes-app" content={"app-id=com.khaleef.cricwicktelenorzong, app-argument="+ window.location.pathname}></meta>
        </Helmet>
        <div>
          <div className={`d-flex justify-content-center mt-4`}>
            <img
              src={getCDNUrl(`/images/friendship.svg`)}
              alt={`Friends`}
              width={70}
              height={`auto`}
            />
          </div>
          <div className={`d-flex justify-content-center mt-3`}>
            {this.state.inviteCode ? (
              <h2 className={"font-weight-bold p-2 m-f-14"}>
                INVITED BY USER:{" "}
                <span className={`redCl`}>{`${this.state.inviteCode}`}</span>
              </h2>
            ) : null}
          </div>
          <div className={`d-flex justify-content-around mt-3`}>
            <div
              className={`redBg whiteCl`}
              style={{
                padding: `10px 15px`,
                borderRadius: `10px`,
                width: "90%",
              }}
            >
              <div>
                <h2 className={"m-f-11 float-left"}>You got:</h2>
              </div>
              <div>
                {this.state.prizePoint.length ? (
                  <h2
                    className={"font-weight-bold float-right"}
                    style={{
                      //lineHeight: `10px`,
                    }}
                  >
                    {`Rs. ${this.state.prizePoint}`}
                  </h2>
                ) : null}
              </div>
            </div>
          </div>
          <div className={`d-flex justify-content-center mt-3`}>
            <div
              className={`lightRedBg`}
              style={{
                padding: `20px 15px`,
                borderRadius: `10px`,
                maxWidth: "90%",
              }}
            >
              <div>
                <h2 className={"font-weight-bold p-2 m-f-14 text-center"}>
                  PSL Live Stream
                </h2>
              </div>
              <div className={"text-center"}>
                {this.returnThingsToDoRow(
                  0,
                  <span>
                    Live stream dekhne or  
                    <span className={`font-weight-bold`}>{` Rs. ${
                      this.state.prizePoint
                    } `}</span>
                    lene k liye abi easypaisa bundle se subscribe karein or payen Pehle hafte
                    <span className={`font-weight-bold`}>{` (${
                      this.state.discount
                    }% discount)`}</span> 
                  </span>
                )}
                {/*{this.returnThingsToDoRow(
                  1,
                  <span>
                    Subscribe with Easy Paisa in just price{" "}
                    <span className={`font-weight-bold`}>{`Rs. 5`}</span> for
                    the first month
                    <span className={`font-weight-bold`}>{` (Save ${
                      this.state.discount
                    }%)`}</span>{" "}
                  </span>
                )}
                {this.returnThingsToDoRow(
                  2,
                  <span>Invite Your Friends to Earn More</span>
                )}*/}
              </div>
              <div className={`d-flex justify-content-center mt-3`}>
                <button
                  className="submit border-0 btn bg-red text-white rounded-0 p-3 text-uppercase font-weight-bold"
                  onClick={() =>
                    this.props.history.push(
                    this.props.userLoggedIn ? "/fantasy" : "/login?fromInvite=true"
                    )
                  }
                >
                {`Rs 20 claim karein`}
                </button>
              </div>
            </div>
          </div>
          <div className="mt-3">
            <div>
              <h2 className="text-center m-f-14 m-2">
                Ya Free Fantasy team banae Fantasy khlene par Rs. 20 Invite Bonus nai mile ga
              </h2>
            </div>
            <div className={`d-flex justify-content-center mt-2`}>
              <button
                className="create-team btn redCl rounded-0 font-weight-bold"
                onClick={() =>
                  this.props.history.push(this.linkToFantasy)
                }
              >
                {`Fantasy Team Banao`}
              </button>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default withRouter(InvitedByFriend);
